import React from 'react';
import { Phone } from 'lucide-react';

export const FloatingCallButton = ({ language }) => {
  return (
    <a
      href="tel:+18194312712"
      data-testid="floating-call-button"
      className="fixed bottom-5 left-5 z-50 md:hidden flex items-center gap-2 bg-orange-500 hover:bg-orange-600 text-white font-bold px-5 py-3 rounded-full shadow-lg shadow-orange-500/40 transition-colors duration-300"
    >
      <Phone className="h-5 w-5 animate-pulse" />
      <span>{language === 'fr' ? 'Appeler Maintenant' : 'Call Now'}</span>
    </a>
  );
};
